import { render, staticRenderFns } from "./QualityTable.vue?vue&type=template&id=a116c0a0&scoped=true"
import script from "./QualityTable.vue?vue&type=script&lang=js"
export * from "./QualityTable.vue?vue&type=script&lang=js"
import style0 from "./QualityTable.vue?vue&type=style&index=0&id=a116c0a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a116c0a0",
  null
  
)

export default component.exports